<template>
  <CompanyShopItemsForm
    :data="formData"
    :errors="errors"
    @submitForm="handleSubmit"
    @initialValidation="initialValidation"
    :has-initial-validation="hasInitialValidation"
    :is-loading="isLoading"
    :heading-text="__('Edit Product')"
  >
  </CompanyShopItemsForm>
</template>
<script setup>
  import { reactive, ref } from 'vue';
  import CompanyShopItemsForm from './CompanyShopProductsForm.vue';
  import axios from 'axios';
  import { useToast } from 'vue-toastification';
  import { __ } from '@/helpers';

  const toast = useToast();
  const props = defineProps({
    data: Object
  });

  const formData = reactive({
    ...(props.data || {})
  });

  const isLoading = ref(false);

  const errors = ref({});
  const hasInitialValidation = ref(false);

  const initialValidation = async (data) => {
    isLoading.value = true;
    hasInitialValidation.value = false;
    try {
      const response = await axios.post(
        route('redesign.company.shop.products.initial_validate'),
        data
      );
      hasInitialValidation.value = true;
    } catch (error) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
        errors.value = error.response.data.errors;
      } else {
        toast.error(__('Something went wrong'));
      }
    } finally {
      isLoading.value = false;
    }
  };

  const handleSubmit = async (event) => {
    isLoading.value = true;
    try {
      const response = await axios.post(
        route('redesign.company.shop.products.update', event.product_id),
        event.data
      );

      sessionStorage.setItem(
        'toast_message',
        JSON.stringify({
          type: 'success',
          message: response.data.message
        })
      );

      window.location.href = response.data.redirect_url;
    } catch (error) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
        errors.value = error.response?.data?.errors;
      } else {
        toast.error(__('Something went wrong'));
      }
    } finally {
      isLoading.value = false;
    }
  };
</script>
